<div
  class="matrix_layoutMain container matrix_layoutUseMatrix"
  v-bind:class="getClassNameContainer"
>
  <div class="row">
    <div class="col-md-9 matrix_layoutMatrixContainerColMain">
      <div class="matrix_layoutHeader">
        <appProductPartsNamesContainer
        ></appProductPartsNamesContainer>
      </div>
      <div class="matrix_productPartsMainContainer matrix_table">
        <appProductParts></appProductParts>
        <appBackToMatrixButton></appBackToMatrixButton>
        <appPersonalizationButton
          class="matrix_personzalizeButtonMain"
          v-show="getMatrixComplete"
        ></appPersonalizationButton>
      </div>
      <div class="matrix_summaryInformation">
        <appSummaryTable></appSummaryTable>
        <appInformationTable></appInformationTable>
      </div>
      <div class="matrix_summaryInformation">
        <appFactsheet></appFactsheet>
      </div>
    </div>
    <div class="col-md-3 matrix_layoutMatrixContainerColSidebar">
      <appQuantityTable>
        <appQuantityContainer></appQuantityContainer>
        <appInputQuantity></appInputQuantity>
      </appQuantityTable>
      <appAddToCartButton
        class="matrix_addToCartButtonMain"
        style="display: none"
      ></appAddToCartButton>
      <appSummarySelectedPageOptions></appSummarySelectedPageOptions>
      <appOtherOptionsTable>
        <appOtherOptionsContainer></appOtherOptionsContainer>
      </appOtherOptionsTable>
      <appOptionsTable>
        <appOptionsContainer></appOptionsContainer>
        <appInputCustomFormatInsert></appInputCustomFormatInsert>
      </appOptionsTable>
      <appPersonalizationButton
        class="matrix_personzalizeButtonMobile"
      ></appPersonalizationButton>
      <appAddToCartButton
        class="matrix_addToCartButtonMobile"
        style="display: none"
      ></appAddToCartButton>
      <appQuotationButton></appQuotationButton>
    </div>
  </div>
</div>
